export default "__VITE_ASSET__TKxNSGVJ__"